var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-rank-list__two-columns" },
    [
      !_vm.styleObject.hideHeader &&
      (!_vm.styleObject.hideTitle ||
        (_vm.styleObject.hideTitle &&
          (_vm.styleObject.hideMyRank ||
            !_vm.rankData.rankList ||
            !_vm.rankData.rankList.length)))
        ? _c(
            "rank-title",
            {
              class: {
                "yxtbiz-rank-list__two-columns-title":
                  !_vm.styleObject.hideHeader &&
                  (!_vm.styleObject.hideTitle || _vm.titleObj.showDate),
              },
              on: {
                changeDate: function ($event) {
                  return _vm.$emit("changeDate", $event)
                },
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "title" }, slot: "title" },
                [_vm._t("title")],
                2
              ),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          class: {
            "yxtbiz-rank-list__two-columns-no-data":
              _vm.height &&
              (!_vm.rankData.rankList || !_vm.rankData.rankList.length),
          },
          style: { height: _vm.height ? _vm.height - 88 + "px" : "auto" },
        },
        [
          _vm.rankData.rankList && _vm.rankData.rankList.length
            ? _c(
                "yxtf-scrollbar",
                { ref: "scrollBox", attrs: { "fit-height": "" } },
                [
                  !_vm.styleObject.hideMyRank &&
                  _vm.titleObj.objectCode === "user"
                    ? _c(
                        "my-rank",
                        {
                          class: [
                            _vm.styleObject.showStyle === 1 ? "mb16" : "mb32",
                          ],
                          attrs: {
                            myRankData: _vm.rankData.myRankData,
                            styleType: 2,
                          },
                          on: {
                            changeDate: function ($event) {
                              return _vm.$emit("changeDate", $event)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "title" }, slot: "title" },
                            [_vm._t("title")],
                            2
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.styleObject.showStyle === 2
                    ? _c("horizontal-head", {
                        staticClass: "mt32",
                        attrs: {
                          "rank-data": _vm.rankData.rankList.slice(0, 3),
                        },
                      })
                    : _vm._e(),
                  _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex-1 yxtbiz-rank-list__two-columns-first-line",
                      },
                      _vm._l(_vm.firstLine, function (item, index) {
                        return _c(
                          "div",
                          { key: index },
                          [_c("row-item", { attrs: { rowData: item } })],
                          1
                        )
                      }),
                      0
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex-1 yxtbiz-rank-list__two-columns-second-line",
                      },
                      _vm._l(_vm.secondLine, function (item, index) {
                        return _c(
                          "div",
                          { key: index },
                          [_c("row-item", { attrs: { rowData: item } })],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              )
            : _c("div", [
                _vm.initFlag < 1
                  ? _c(
                      "div",
                      [
                        _vm.errorTip === "pc_biz_rank_calculating"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "flex yxtbiz-rank-list__two-columns-calculating",
                              },
                              [
                                _c("yxtf-svg", {
                                  attrs: {
                                    width: "16px",
                                    height: "16px",
                                    "icon-class": "loading",
                                  },
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "standard-size-14 text-8c yxtbiz-rank-list__two-columns-calculating-tip",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("pc_biz_rank_calculating"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _c("yxtf-empty", {
                              attrs: {
                                size: "small",
                                "empty-text": _vm.$t(_vm.errorTip),
                              },
                            }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }